import React from 'react';
import WorkTime from '../components/workTime.jsx';
const WorkPage = () => {
    return (
        <div>
            <WorkTime></WorkTime>
        </div>
    )
};
export default WorkPage;